import { useCallback, useMemo } from 'react'
import type { MapRef } from 'react-map-gl'
import type { MapEvent } from 'mapbox-gl'
import {
  MAPBOX_STYLE_STREET,
  MAPBOX_STYLE_SATELLITE,
} from '../../../../../config/env'

interface UseMapStyleAndIconsParams {
  mapRef: React.MutableRefObject<MapRef | null>
  mapType: 'street' | 'satellite'
  onMapReady?: (mapApi: {
    search: (lat: number, lng: number, zoom?: number) => void
  }) => void
}

export const useMapStyleAndIcons = ({
  mapType,
  onMapReady,
}: UseMapStyleAndIconsParams) => {
  const mapStyle = useMemo(
    () =>
      mapType === 'satellite' ? MAPBOX_STYLE_SATELLITE : MAPBOX_STYLE_STREET,
    [mapType]
  )

  const handleMapLoad = useCallback(
    async (e: MapEvent) => {
      const map = e.target

      if (onMapReady) {
        onMapReady({
          search: (lat: number, lng: number, zoom: number = 12) => {
            map.flyTo({
              center: [lng, lat],
              zoom,
              duration: 500,
            })
          },
        })
      }
    },
    [onMapReady]
  )

  // Removed redundant useEffect that manually sets map style
  // The mapStyle is handled by the Map component prop in MapView.tsx
  // This prevents double-initialization and race conditions during map load

  return { mapStyle, handleMapLoad }
}
